module.exports = __webpack_public_path__ + "img/second-section.17b33d68.webp";